import {useContext} from 'react'
import Search from '../../../../components/Search'
import {ProductsReportPageContext} from '../../contexts'

const ProductsHeader = () => {
  const {onSearch} = useContext(ProductsReportPageContext)

  return (
    <div className='d-flex justify-content-between mb-10'>
      <div>
        <Search
          onSearch={(searchTerm: string) => {
            onSearch(searchTerm)
          }}
        />
      </div>
    </div>
  )
}

export default ProductsHeader
